'use client'

import { useMemo, useState } from "react"
import { DatasetAreaChart, DatasetSource } from "./charts/dataset-area-chart"
import { useSkyOverviewResults } from "@/hooks/useQueryResults"
import { Percent, Sigma } from "lucide-react"


export function SkyTokenOverview() {
    const [showPct, setShowPct] = useState(false)
    const percentFormatter = new Intl.NumberFormat("en", {style: 'percent', maximumFractionDigits: 2})
    const formatter = new Intl.NumberFormat("en", {currency: "USD", currencyDisplay: 'narrowSymbol', style: 'currency', maximumFractionDigits: 0})
    const axisFormatter = new Intl.NumberFormat('en', {notation: 'compact', currency: "USD", currencyDisplay: 'narrowSymbol', style: 'currency'})

    const { results } = useSkyOverviewResults()

    const dataset: DatasetSource = useMemo(() => {
        if (!results) return {source: [[]]}
        let source: DatasetSource['dimensions'] = ['Date', 'Token Rewards', 'USDS', 'sUSDS', 'stUSDS', 'Dai Savings Rate', 'DAI']
        return {
            dimensions: source,
            source: results.map(
                (r) => [
                    r.date.toDate(),
                    Number(r.token_rewards),
                    Number(r.usds),
                    Number(r.susds),
                    Number(r.stusds),
                    Number(r.dsr),
                    Number(r.dai)
                ])
        }
    }, [results])

    const pctData = useMemo(() => {
        return {
            dimensions: dataset.dimensions,
            source: dataset.source.map(s => {
                const sum = s.slice(1).reduce((a, i) => (a as number) + (i as number), 0) as number
                return [s[0], ...s.slice(1).map(v => (v as number)/sum)]
            }).filter(s => !Number.isNaN(s[1]))
        }
    }, [dataset])

    const _switch = () => setShowPct(!showPct)

    return <div className='w-full h-[40vh]'>
        <DatasetAreaChart
            dataset={showPct?pctData:dataset}
            title="USDS Total Supply"
            description="Split by product and excluding sUSDS in L2 ALM / PSM buffers"
            stack
            showTotal
            yAxisScale={false}
            yAxisFormatter={(n) => showPct?percentFormatter.format(n):axisFormatter.format(n)}
            tooltip={{
                seriesValueFormatter: (value) => showPct?percentFormatter.format(value):`${formatter.format(value)}`
            }}
            legendActions={[
                {
                    name: `Switch to ${showPct?'nominal':'percent'} view`,
                    action: _switch,
                    icon: showPct?Sigma:Percent
                }
            ]}
        />
    </div>
}
